module.exports = __webpack_public_path__ + "iq.svg?0336bb4b44029e461629eb2e6ab2471b";